import AuthService from '../security/AuthService';

const eventBus = {


  /*on(event, callback) {
    document.addEventListener(event, (e) => callback(e.detail));
  },
  dispatch(event, data) {
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  },
  remove(event, callback) {
    document.removeEventListener(event, callback);
  },*/
  dispatch(event, props) {
    console.log(event,props?.history, props,props?.history,props?.history)
    AuthService.doLogout();
    if (props?.history) {
      props.history.push('/');
    }
  },

};

export default eventBus;
